import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

function Screen(props) {
	return <div
		className = {props.classes.root}
		onClick = {props.onClick}
	>
		{props.children}
	</div>
}

export default withStyles(theme => ({
	root: {
		alignItems: "center",
		marginTop: theme.spacing.unit * 2,
		display: "flex",
	    flexDirection: "column",
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
		[theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
	       width: 600,
	       marginLeft: 'auto',
	       marginRight: 'auto',
	    },
	},
}))(Screen)
